<template>
  <component
    :is="type == 'link' ? 'router-link' : 'button'"
    :class="
      '_button_1t1tt_1 ' +
      [full ? '_button-full_1t1tt_22 ' : ''] +
      [
        fontSize == 'medium'
          ? '_md_1e8ul_61 '
          : fontSize == 'small'
          ? '_sm_1e8ul_61 '
          : fontSize == 'extra-small'
          ? '_xs_1e8ul_63 '
          : ''
      ] +
      [
        size == 'medium'
          ? '_button-md_1t1tt_63 '
          : size == 'small'
          ? '_button-sm_1t1tt_57 '
          : size == 'extra-small'
          ? '_button-xs_1t1tt_51 '
          : '_button-xss_1t1tt_51 '
      ] +
      [
        color == 'primary'
          ? '_button-primary_1t1tt_26 '
          : color == 'light'
          ? '_button-light_1t1tt_37 '
          : color == 'success'
          ? '_button-success_1t1tt_44 '
          : color == 'danger'
          ? '_button-danger_1t1tt_46 '
          : color == 'success-all'
          ? '_button-success_all_1t1tt_44 '
          : color == 'danger-all'
          ? '_button-danger_all_1t1tt_46 '
          : color == 'link'
          ? '_button-link_1t1tt_32 '
          : color == 'text'
          ? '_button-text_1t1tt_42 '
          : color == 'alert'
          ? '_button-alert_1t1tt_50 '
          : color == 'light-success'
          ? '_button-light-success_1t1tt_46'
          : ' '
      ] +
      [loading || disabled ? '_button-disabled_1t1tt_17' : '']
    "
    :disabled="loading || disabled"
    :to="to"
    :type="type == 'link' ? 'button' : type"
    @click="clicked"
  >
    <div v-if="loading" class="_spinner_p5ti9_1 _small_p5ti9_29"></div>
    <slot v-else />
  </component>
</template>

<script>
export default {
  name: 'AbanButton',
  emits: ['click'],
  props: {
    loading: {
      default: false
    },
    color: {
      default: 'primary'
    },
    size: {
      default: 'medium'
    },
    full: {
      default: false
    },
    type: {
      default: 'submit'
    },
    fontSize: {
      default: 'medium'
    },
    disabled: {
      default: false
    },
    preventDefault: {
      default: false
    },
    to: {
      default: null
    }
  },
  methods: {
    clicked(event) {
      if (this.preventDefault) event.preventDefault()
      this.$emit('click')
    }
  }
}
</script>
